import { h } from 'preact';
import Image from '../utils/image';

const CustomizeButton = ({ classes }) => (
  <Image
    src="https://cdn.shopify.com/s/files/1/0574/8041/3232/files/CSTM-withworkmark-4x.png?v=1686336874"
    className={`object-contain ${classes}`}
    width={63}
    height={20}
    alt={`Customize button`}
  />
);

export default CustomizeButton;
